import { ClinicalRelationships } from '../../../../../../../constants';

import type { IProvider, IProviderAssignment } from '../../../../../../../utils/types';

export function buildBtProviderNamesFromSources(
  coAssignedProviders: IProvider[] | undefined,
  providerAssignments: IProviderAssignment[],
): string[] {
  const fromCoAssigned =
    coAssignedProviders?.map(
      (coAssignedProvider) =>
        `${coAssignedProvider?.first_name}${
          coAssignedProvider?.last_name ? ` ${coAssignedProvider.last_name}` : ''
        }`,
    ) ?? [];
  if (fromCoAssigned.length > 0) {
    return fromCoAssigned;
  }
  return providerAssignments
    .filter(
      (providerAssignmentIterator) =>
        providerAssignmentIterator?.clinical_relationship === ClinicalRelationships.Prbt ||
        providerAssignmentIterator?.clinical_relationship === ClinicalRelationships.Vbt,
    )
    .map(
      (providerAssignment) =>
        `${providerAssignment?.provider.first_name}${
          providerAssignment?.provider.last_name ? ` ${providerAssignment.provider.last_name}` : ''
        }`,
    );
}
